import {
  TableHeader,
  TableRow,
  TableHead,
} from 'src/shared/components/ui/table'
import { Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const OrderTableHeader = ({
  showDiscountColumn = true,
}: {
  showDiscountColumn?: boolean
}) => {
  const { t } = useLocalization()

  return (
    <TableHeader className="[&_tr]:border-0 max-sm:hidden">
      <TableRow className="border-none hover:bg-transparent [&_th]:h-auto [&_th]:py-2.5 [&_th]:text-xs [&_th]:font-medium [&_th]:uppercase [&_th]:tracking-wide">
        <TableHead className="text-muted-foreground">
          {t('Description', 'Beskrivning')}
        </TableHead>
        {showDiscountColumn && (
          <TableHead className="text-center text-muted-foreground">
            {t('Discount', 'Rabatt')}
          </TableHead>
        )}
        <TableHead className="pl-2 pr-4 text-muted-foreground">
          <Row className="w-full items-center justify-end gap-8">
            <span className="w-14 shrink-0 text-center">
              {t('Quantity', 'Antal')}
            </span>
            <span className="min-w-0 flex-1 text-right">
              {t('Total', 'Totalt')}
            </span>
            <div className="w-5 shrink-0" />
          </Row>
        </TableHead>
      </TableRow>
    </TableHeader>
  )
}
